import queryString from "query-string";
import { BaseParams } from "types";
import { RtkTagTypes } from "types/enums";
import { apiService } from "../apiService";

const BASE_ROUTE = "/organizationPortal";

export interface OrganizationPortalSubmissionParams extends BaseParams {
  status?: string;
}

const organizationPortalEndpoint = apiService.injectEndpoints({
  endpoints: (builder: any) => ({
    getOrganizationPortalSubmissions: builder.query({
      query: (params: OrganizationPortalSubmissionParams) =>
        `${BASE_ROUTE}/submissions?${queryString.stringify(params)}`,
      providesTags: [RtkTagTypes.GetPortalSubmissions],
      transformResponse: (response: any, meta: any) => {
        const pagination = meta.response.headers.get("Pagination");
        return { data: response, pagination };
      },
    }),
    getOrganizationPortalSubmissionById: builder.query({
      query: (id: number) => `${BASE_ROUTE}/submissions/${id}`,
      providesTags: (_: any, __: any, id: number) => [
        { type: RtkTagTypes.GetPortalSubmissions, id },
      ],
    }),
    getDescriptionForEventFromSubmission: builder.query({
      query: (id: number) =>
        `${BASE_ROUTE}/submissions/${id}/descriptionForEvent`,
    }),
    updateOrganizationPortalSubmissionStatus: builder.mutation({
      query: ({ id, status }: { id: number; status: string }) => ({
        url: `${BASE_ROUTE}/submissions/${id}/status`,
        method: "PATCH",
        body: { status },
      }),
      invalidatesTags: [RtkTagTypes.GetPortalSubmissions],
    }),
  }),
});

export const {
  useGetOrganizationPortalSubmissionsQuery,
  useLazyGetOrganizationPortalSubmissionByIdQuery,
  useLazyGetDescriptionForEventFromSubmissionQuery,
  useUpdateOrganizationPortalSubmissionStatusMutation,
} = organizationPortalEndpoint;
